<template>
  <div class="fSize">
    <!--<p>订单列表...</p>-->
    <van-tabs v-model="listQuery.status" @click="changeTab" line-width="1rem">
      <van-tab v-for="(i,index) in tabs" :title="i" :key="index">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" @load="getList" :error.sync="error"
                    error-text="请求失败，点击重新加载">
            <van-cell-group v-for="item in list" :key="item.id" class="newGroup">
              <van-cell :border="false">
                <van-row>
                  <van-col span="16">{{ item.createTime }}</van-col>
                  <van-col span="8" :style="changeStyle(item.status)[1]">
                    {{ changeStyle(item.status)[0] }}
                  </van-col>
                </van-row>
              </van-cell>
              <van-cell :border="false" :center="true" @click="goDetail(item)"
                        class="newCell">
                <van-row align="center" type="flex" gutter="12">
                  <van-col>
                    <van-image class="newImage" width="100" height="100" :src="item.imageUrl1"/>
                  </van-col>
                  <van-col>
                    <van-row type="flex" gutter="12">
                      <van-col>{{ item.productName }}</van-col>
                      <van-col>x{{ item.buyNum }}</van-col>
                    </van-row>
                    <van-row>{{ item.type === 'combo' ? '套餐' : item.type === 'value_card' ? '储值卡' : '代金券' }}
                    </van-row>
                  </van-col>
                </van-row>
                <van-row type="flex" justify="end">
                  <van-col span="6" style="text-align:right">{{ '单价' + item.productPrice / 100 }}</van-col>
                  <van-col span="6" style="text-align:right">{{ '数量' + item.buyNum }}</van-col>
                  <van-col span="6" style="text-align:right">{{ '总价' + item.buyMoney / 100 }}</van-col>
                </van-row>
              </van-cell>
              <van-cell v-if="item.status === '1'" :border="false" class="newCell2">
                <template #extra>
                  <van-button class="newButton leftG" hairline plain round size="small"
                              type="info" @click="delOrder(item.id)" text="取消订单"/>
                  <van-button class="newButton" hairline plain round size="small" type="info"
                              @click="goOrder(item)" text="去支付"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <!--去支付-->
    <van-action-sheet safe-area-inset-bottom :round="false" v-model="showBase" title="订单与支付">
      <OrderAndBuy @fatherMethod="closeChild" :item="detail"></OrderAndBuy>
    </van-action-sheet>
    <!--去退款-->
    <van-action-sheet safe-area-inset-bottom :round="false" v-model="showTui" title="退款申请">
      <OrderRefund @fatherMethod="closeTui" :item="refund"></OrderRefund>
    </van-action-sheet>
    <van-empty v-show="showEmpty" description="暂无订单数据..."/>
  </div>
</template>
<script>
import {
  Tab, Tabs, List, PullRefresh, Cell, CellGroup, Row, Col, Button, Dialog, Toast, ActionSheet, Icon,
  Image as VanImage, Empty
} from "vant";
import {getOrderList, deleteOrder} from "@/api/order";
import {getSetMeal} from "@/api/common";
import OrderAndBuy from "@/components/OrderAndBuy";
import OrderRefund from "@/components/OrderRefund";

export default {
  components: {
    [Tab.name]: Tab, [Tabs.name]: Tabs, [List.name]: List, [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell, [CellGroup.name]: CellGroup, [Row.name]: Row, [Col.name]: Col, [Button.name]: Button,
    [Dialog.name]: Dialog, [Toast.name]: Toast, OrderAndBuy, OrderRefund, [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon, [VanImage.name]: VanImage, [Empty.name]: Empty
  },
  data() {
    return {
      tabs: ["全部", "待付款", "已付款"],
      list: [],
      error: false,
      errorText: "请求失败，点击重新加载",
      loading: false,
      finished: false,
      refreshing: false,
      listQuery: {
        page: 1,
        limit: 10,
        status: null
      },
      //-----
      showBase: false,
      detail: null,
      //-----
      showTui: false,
      refund: null,
      //-----
      showEmpty: false
    };
  },
  created() {
    ///-----
  },
  mounted() {
    var _this = this;
    window.history.pushState(null, null, "#");
    window.addEventListener(
        "popstate",
        _this.closePage,
        false
    );
  },
  methods: {
    closePage() {
      WeixinJSBridge.call("closeWindow");
    },
    //根据status值输出内容
    /*changeStyle(i) {
        let name = null;
        let color = null;
        switch (i) {
            case "1":
                name = "待付款";
                color = "color:#F56C6C;text-align:right;";
                break;
            case "2":
                name = "已付款";
                color = "color:#E6A23C;text-align:right;";
                break;
            case "3":
                name = "已使用";
                color = "color:#67C23A;text-align:right;";
                break;
            case "4":
                //name = "已使用";
                name = "部分使用";
                color = "color:#67C23A;text-align:right;";
                break;
            case "5":
                name = "已退款";
                color = "color:#909399;text-align:right;";
                break;
            case "6":
                //name = "已退款";
                name = "待退款";
                color = "color:#909399;text-align:right;";
                break;
            default:
                name = "全部";
                color = "color:#000000;text-align:right;";
                break;
        }
        return [name, color];
    },*/
    changeStyle(i) {
      let name = null;
      let color = null;
      switch (i) {
        case "unpay":
          name = "待付款";
          color = "color:#F56C6C;text-align:right;";
          break;
        case "payed":
          name = "已付款";
          color = "color:#E6A23C;text-align:right;";
          break;
        default:
          name = "未知";
          color = "color:#000000;text-align:right;";
          break;
      }
      return [name, color];
    },
    //条件重置
    reset() {
      const that = this;
      that.listQuery.page = 1;
      that.listQuery.limit = 10;
      that.finished = false;
      that.error = false;
      that.errorText = "请求失败，点击重新加载";
      that.list = [];
    },
    //标签栏切换
    changeTab(e) {
      this.reset();
      this.getList();
    },
    //获取订单页面
    getList() {
      const that = this;
      // 将 loading 设置为 true，表示处于加载状态
      that.loading = true;
      that.showEmpty = false;
      // 组装请求参数
      let params = this.packageParams(that.listQuery);
      getOrderList(params).then(resp => {
        this.loading = false;
        if (resp.code === 200) {
          that.listQuery.page = that.listQuery.page + 1;
          let newArray = resp.data ? resp.data : [];
          that.list.push.apply(that.list, newArray);
          if (that.list.length >= resp.count) {
            that.finished = true;
          }
          if (that.list.length === 0) {
            that.showEmpty = true;
          }
        } else {
          that.error = true;
          that.errorText = resp.msg + "，请点击重试";
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //下拉刷新
    onRefresh() {
      const that = this;
      // 清空列表数据
      that.reset();
      that.refreshing = false;
      // 重新加载数据
      this.getList();
    },
    //订单删除
    delOrder(id) {
      const that = this;
      Dialog.confirm({
        //title: '标题',
        message: "确定取消此条订单吗？"
      }).then(() => {
        // on confirm
        deleteOrder({
          id: id,
          openId:
              sessionStorage.getItem("openid") || "oQv646by-HepzFd0hqcuIxqTtr20"
        }).then(resp => {
          if (resp.code === 200) {
            Toast.success("订单取消成功！");
            let index = that.listQuery.status;
            setTimeout(function () {
              that.reset();
              that.listQuery.status = index;
              that.getList();
            }, 2000);
          } else {
            Toast.fail(resp.msg);
          }
        }).catch(err => {
          console.log(err);
        });
      }).catch(() => {
        // on cancel
        console.log("取消了删除[" + id + "]！");
      });
    },
    //去购买
    goOrder(item) {
      const that = this;
      that.detail = null;
      Toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0
      });
      getSetMeal({openId: sessionStorage.getItem("openid"), productCode: item.productCode}, 1).then(resp => {
        let data = resp.code === 200 && resp.data ? resp.data : {};
        Toast.clear();
        if (data) {
          //数据组装
          data.personal = ("" + item.userId).split(","); //初始化用户
          data.count = item.buyNum; //购买数量
          data.amount = item.buyMoney; //购买总价
          data.buyOrderCode = item.buyOrderCode;
          //传递子组件数据//展示子组件
          that.detail = JSON.stringify(data);
          that.showBase = true;
        } else {
          //为空处理
          Dialog.alert({
            message: "套餐信息不存在..."
          }).then(() => {
            window.removeEventListener(
                "popstate",
                that.closePage
            );
            that.$router.push({path: "/buyCard"});
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //去退款
    goRefund(item) {
      const that = this;
      //传递子组件数据//展示子组件
      that.refund = JSON.stringify(item);
      that.showTui = true;
    },
    //去订单详情页面
    goDetail(item) {
      const that = this;
      window.removeEventListener(
          "popstate",
          that.closePage
      );
      that.$router.push({
        path: "/orderDetail",
        query: item
      });
    },
    //关闭子组件窗口
    closeChild() {
      const that = this;
      that.showBase = false;
      that.detail = null;
    },
    closeTui() {
      const that = this;
      that.showTui = false;
      that.refund = null;
      //成功后刷新数据
      that.reset();
      that.getList();
    },
    // 打包请求订单列表所需的参数
    packageParams(inParams) {
      let outParams = JSON.parse(JSON.stringify(inParams));
      outParams.openId = sessionStorage.getItem("openid");
      switch (inParams.status) {
        case 0:
          outParams.status = null;
          break;
        case 1:
          outParams.status = "unpay";
          break;
        case 2:
          outParams.status = "payed";
          break;
        default:
          outParams.status = null;
      }
      return outParams;
    }
  }
};
</script>
<style scoped>
.newGroup {
  margin: 0.1rem 0;
}

.newCell {
  padding: 0 0.32rem !important;
}

.newCell2 {
  min-height: 0.84rem;
  padding-top: 0;
}

.newButton {
  width: 1.5rem;
  position: absolute;
  right: 0.32rem;
}

.leftG {
  right: 1.9rem;
}
</style>
